import React from "react";
import logo from "../media/logo.svg";

const DesignUpdate = ({ onClose }) => {
  React.useEffect(() => {
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, []);

  return (
    <div className="design-reveal" role="dialog" aria-modal="true">
      <div className="design-reveal__glow glow-primary" />
      <div className="design-reveal__glow glow-accent" />

      <div className="design-reveal__frame">
        <div className="design-reveal__hero">
          <div className="design-reveal__logo-wrap">
            <img src={logo} alt="Inspiro Еда" />
          </div>
          <div className="design-reveal__copy">
            <p className="design-reveal__eyebrow">Новый дизайн</p>
            <h1 className="design-reveal__title">
              Ничего лишнего. Всё по делу.
            </h1>
            <p className="design-reveal__subtitle">
              Заказывать стало проще, чем объяснять.
            </p>
            <button className="btn btn-primary design-reveal__cta" onClick={onClose}>
              Посмотреть
              <i className="bi bi-arrow-right-short ms-2" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DesignUpdate;
